import { useUserContext } from "@/app/_hooks/useUserContext";
import { useRefreshSubscription } from "../subscription/useSubscriptionContext";
import { authenticatedFetch } from "@/app/_utils/authenticatedFetch";

interface StageUpdateArgs {
  clientUid: string;
  clientPhone: string;
  jobUid?: string;
  jobId?: number;
  updates: Array<{
    specimen: string;
    stage: string;
  }>;
}

const useSendStageUpdateSMS = () => {
  const {
    phone,
    uid,
    settings: { name },
  } = useUserContext();
  const refreshSubscription = useRefreshSubscription();

  const sendStageUpdateSMS = async ({
    clientUid,
    clientPhone,
    jobUid,
    jobId,
    updates,
  }: StageUpdateArgs): Promise<string> => {
    try {
      const body = {
        clientUid,
        clientPhone,
        jobUid,
        jobId,
        storeName: name,
        updates,
      };

      const response = await authenticatedFetch("/api/sms/stageUpdate", {
        method: "POST",
        body: JSON.stringify(body),
      });

      if (response.ok) {
        refreshSubscription();
        return "SMS sent";
      } else {
        return "SMS failed";
      }
    } catch (error) {
      return "SMS failed";
    }
  };

  return sendStageUpdateSMS as (args: StageUpdateArgs) => Promise<string>;
};

export default useSendStageUpdateSMS;
